import getCombinedExercisesData from './getCombinedExercisesData'

/**
 * Convert the data from Difficulty into an object array
 *
 * @param entry
 * @param type
 * @returns {{easierTitle: "", easierList: [], harderTitle: "", harderList: []}[]}
 */
export default function getTrainingExerciseListData(entry, type) {
  if (!entry) return null

  const data = []
  const exercises = getCombinedExercisesData(entry)

  if (exercises) {
    const listData = []
    exercises.map((exercise) => {
      if (type && type === 'detailCard') {
        listData.push({ li: exercise.exerciseTitle })
      } else {
        listData.push({ li: exercise.title })
      }
      return ''
    })

    if (type && type === 'detailCard') {
      data.push({ ul: listData })
    } else {
      data.push({ ol: listData })
    }
  }

  return data
}
